export enum ROUTES {
  SURVEY = '/survey',
  SIGN_UP = '/sign-up',
  SHARE_COLLECTION = '/share/collections/:token',
  DOWNLOAD_APP = '/download-app',
  PLAID_FAILED = '/plaid-failed',
}
